module.exports = __webpack_public_path__ + "img/ertiga-xl7-blanco.628502dd.png";